import React, { useState, useRef, useEffect, createRef } from "react";
import "./styles.scss";

import Rating from "../../../common/rating";

const AboutUsSection = (props) => {
  const { title, reviews } = props;
  const [expandedIndex, setExpandedIndex] = useState(-1);
  const contentRefs = useRef(reviews?.map(() => createRef()));
  const [contentHeights, setContentHeights] = useState([]);

  useEffect(() => {
    // Calculate content heights
    const heights = contentRefs.current.map((ref) => ref.current.scrollHeight);
    setContentHeights(heights);
  }, [reviews]);

  const toggleText = (index) => {
    setExpandedIndex((prevIndex) => (prevIndex === index ? -1 : index));
  };

  return (
    <div className="aboutus-container">
      <p className="title">{title}</p>
      <div className="section">
        {reviews?.map((item, index) => (
          <div key={index}>
            <h3>{item?.name}</h3>
            <Rating
              value={parseInt(item?.ratings)}
              ratingValue={parseInt(item?.ratings)}
            />
            <p
              dangerouslySetInnerHTML={{ __html: item?.comment }}
              className={`box ${expandedIndex === index ? "expanded" : ""}`}
              ref={contentRefs.current[index]}
              style={{
                maxHeight:
                  expandedIndex === index
                    ? contentHeights[index] + "px"
                    : "63px",
                overflow: "hidden",
              }}
            />
            {contentHeights[index] > 63 && (
              <span onClick={() => toggleText(index)}>
                {expandedIndex === index ? "Read Less" : "Read More"}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutUsSection;
